import Container from '@mui/material/Container';
import Skeleton from '../../../componentsv2/Skeleton';

export default function ViewInvoiceSkeleton() {
  return (
    <Container sx={{ paddingTop: '40px', paddingBottom: '64px' }}>
      <Skeleton variant="rectangular" height={400} animation="wave" />
    </Container>
  );
}
